/**
 * Setup the PPClientInteractions logger to use app beaver-logger instance
 */

// @ts-expect-error - beaver is not typed
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function setupCiLogger(loggerInstance, weasleyLogger): void {
  // Change over from window.logPayload to beaver-logger
  if (!window.PPClientInteractions?.interaction?.setLogger) {
    if (process.env.NODE_ENV !== 'test') {
      weasleyLogger.error('FAILED_TO_LOAD_CLIENT_INTERACTION_LIBRARY');
    }
  } else {
    window.PPClientInteractions.interaction.setLogger(events => {
      // In local dev log to the console for easy debugging.
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.debug('Interactions Event: ', events);
      }

      if (!events?.length) {
        return;
      }

      events.forEach(event => {
        const interaction = event?.interaction || 'missing_interaction_name';
        const dimensions = {
          clientApp: event?.clientApp,
          errorReason: event?.errorReason,
          flow: event?.flow,
          interaction,
          page: event?.page,
          releaseDate: event?.releaseDate,
          status: event?.status,
        };

        // If an FCI occurs push to Cal as well for debugging
        if (dimensions.status === 'FCI') {
          weasleyLogger.error(`FCI_${interaction.toUpperCase()}`, dimensions);
        }

        loggerInstance.metric({
          dimensions,
          metricEventName: 'n/a',
          metricNamespace: event?.metricName,
        });
      });
    });
  }
}
